<template>
    <div class="works">
        <div class="first">
            <info-section 
                :data="works_data" 
                :render="works_data.render" 
                :leave="works_data.leave">
            </info-section>
        </div>
        <div class="container-sb">
            <div class="top-tools">
                <div class="category-select">
                    <select multiple v-model="categories">
                        <option value="" disabled selected>Filtrar por categorías</option>
                        <option value="website">Sitio Web</option>
                        <option value="landing_page">Landing Page</option>
                        <option value="digital_flyer">Volante Digital</option>
                        <option value="plataform">Plataforma</option>
                        <!-- <option value="svg_animation">Animación SVG</option> -->
                        <!-- <option value="business_card">Tarjeta de Presentación</option> -->
                    </select>
                </div>
            </div>
            <div class="container-cards">
                <!-- Item card -->
                <work-card 
                    v-for="(work_card, index) in filter_work_cards" 
                    :key="index"
                    :work_card="work_card">
                </work-card>
            </div>
        </div>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <!-- FOOTER -->
        <footer-sb></footer-sb>
    </div>
</template>

<script>
import WorkCardComponent from '@/components/Works/WorkCardComponent'
export default {
    components: {
        'work-card': WorkCardComponent
    },
    data() {
        return {
            // About Me
            works_data: {
                render: false,
                leave: false,
                title: 'MIS TRABAJOS',
                description: 'Estos son algúnos proyectos recientes en los que he trabajado.',
                buttonText: 'Explorar',
                button_link: { type: 'ext', link: 'https://www.linkedin.com/in/sebastian-b%C3%A1ez-a461a2176/' },
                image: { full: true, url: 'home/works.jpg' }
            },
            //
            categories: [],
            work_cards: [
                // WEBSITE
                {
                    image: 'website/sebasbaez/desktop.png',
                    title: 'Sebastian Báez Code',
                    description: 'Página Web para mostrar quién soy y los trabajos que he realizado.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["vue", "sass", "js", "git"],
                    categories: ["website"]
                },
                {
                    image: 'website/king-wash/desktop.png',
                    title: 'King Wash - Embellecimiento Automotriz',
                    description: 'Página Web con panel de administración para gestionar reservas online, cupones de dcto, etc.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["vue", "sass", "js", "lumen", "my_sql", "git"],
                    categories: ["website", "plataform"],
                    external_link: 'https://kingwash.co'
                },
                {
                    image: 'website/ummami/desktop.jpg',
                    title: 'Ummami Express',
                    description: 'Página Web para la empresa Ummami Express, restaurante de comida variada con pedidos online.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["vue", "sass", "js", "lumen", "my_sql", "git"],
                    categories: ["website", "plataform"],
                    external_link: 'https://ummamiexpress.com'
                },
                {
                    image: 'website/winketing/desktop.png',
                    title: 'Winketing',
                    description: 'Página Web para la empresa Winketing, agencia de marketing digital.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js", "my_sql", "git"],
                    categories: ["website"],
                    external_link: 'https://winketing.com/'
                },
                {
                    image: 'website/industrias-pico/desktop.jpg',
                    title: 'Industrias Pico',
                    description: 'Página Web para la empresa Industrias Pico, diseñada para la presentación de estanterías, muebles, entre otros.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["vue", "sass", "js", "my_sql", "git"],
                    categories: ["website"],
                    external_link: 'https://winketing.com/industrias-pico/'
                },
                {
                    image: 'website/lemarm/desktop.jpg',
                    title: 'Le Marm - Propuesta',
                    description: 'Propuesta de diseño web para la empresa Le Marm, enfocada a la venta de diseño interior.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["website"],
                    external_link: 'https://winketing.com/lemarm/'
                },
                {
                    image: 'website/odontomedicas/desktop.png',
                    title: 'Odontomedicas',
                    description: 'Página Web para la empresa Odontomedicas, servicios de medicina general y especializado en odontología.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["wordpress", "my_sql"],
                    categories: ["website"],
                    external_link: 'https://odontomedicas.com/'
                },
                // Landing pages / Flyer
                {
                    image: 'landing-pages/pagina-web/desktop.png',
                    title: '¿Necesitas una página web?',
                    description: `
                        Landing Page/Volante para la atracción de clientes interesados en un sitio web.
                    `,
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js", "my_sql"],
                    categories: ["landing_page", "digital_flyer"],
                    external_link: 'https://www.winketing.com/volantes/productos/pagina-web/'
                },
                {
                    image: 'landing-pages/social-marketing/desktop.jpg',
                    title: 'Social Media Marketing',
                    description: `
                        Landing Page para promocionar marketing social media marketing para la empresa Winketing.
                    `,
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page"],
                    external_link: 'https://winketing.com/social-marketing/'
                },
                {
                    image: 'landing-pages/promociones-taikinsa/desktop.jpg',
                    title: 'Beneficios Taikinsa - Hotel Dann',
                    description: 'Landing Page para la atracción de clientes en Taikinsa y Hotel Dann.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page"],
                    external_link: 'https://promociones.taikinsa.com/taikinsadann/programa-de-beneficios/'
                },
                {
                    image: 'landing-pages/pico/desktop-1.png',
                    title: 'Silla Ergohuman',
                    description: 'Landing Page/Volante para la atracción de clientes interesados en una silla ergonómica.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page", "digital_flyer"],
                    external_link: 'https://industriaspico.com/silla-ergohuman/'
                },
                {
                    image: 'landing-pages/marketing-automatizado/desktop.jpg',
                    title: 'Marketing Automatizado',
                    description: 'Landing Page para la atracción de clientes interesados en el marketing automatizado.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page"],
                    external_link: 'https://winketing.com/marketing-automatizado/'
                },
                {
                    image: 'landing-pages/vioss/desktop.png',
                    title: 'Vioss - Un regalo para una madre',
                    description: 'Landing Page/Volante para la atracción de clientes interesados en un regalo para el día de las madres.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page", "digital_flyer"],
                    external_link: 'https://winketing.com/volantes/productos/vioss/'
                },
                {
                    image: 'landing-pages/volante/desktop.png',
                    title: 'Un volante digital para tu marca',
                    description: 'Landing Page/Volante para la atracción de clientes interesados en un volante digital.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page", "digital_flyer"],
                    external_link: 'https://www.winketing.com/volantes/productos/volante-digital/'
                },
                {
                    image: 'landing-pages/tarjeta-digital/desktop.png',
                    title: 'Tarjeta Digital',
                    description: 'Landing Page para la atracción de clientes interesados en una tarjeta digital.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["wordpress", "sass", "js"],
                    categories: ["landing_page"],
                    external_link: 'https://winketing.com/tarjeta-digital/'
                },
                {
                    image: 'plataform/sistema-de-salud/desktop.png',
                    title: 'Sistema de Salud',
                    description: 'Sistema para gestionar los procesos de salud para los pacientes de una IPS.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["vue", "sass", "js", "lumen", "git", "my_sql"],
                    categories: ["website", "plataform"]
                },
                {
                    image: 'plataform/curso-movilidad/desktop.png',
                    title: 'Plataforma de Cursos Viales',
                    description: 'Plataforma de cursos online, enforcada en la seguridad vial y relacionadas.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["vue", "sass", "js", "lumen", "git", "my_sql"],
                    categories: ["website", "plataform"]
                },
                {
                    image: 'landing-pages/asesoria-gratuita/desktop.png',
                    title: 'Asesoria Gratuita de Marketing',
                    description: 'Landing Page para la atracción de clientes interesados en hacer crecer usando marketing digital.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js", "my_sql"],
                    categories: ["landing_page"],
                    external_link: 'https://winketing.com/asesoria-gratuita/'
                },
                {
                    image: 'landing-pages/tratamientos/desktop.png',
                    title: 'Vivemas - Tramiento de enfermedades',
                    description: 'Landing Page para la atracción de clientes interesados en brigadas médicas.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js", "my_sql"],
                    categories: ["landing_page"],
                    external_link: 'https://vivemas.com.co/tratamiento-enfermedades/'
                },
                {
                    image: 'tienda-online/vivemas/desktop.png',
                    title: 'Vivemas - Tienda de productos',
                    description: 'Tienda online modificando la plantilla base de Prestashop para la venta de productos homeopáticos.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js", "my_sql"],
                    categories: ["website", "plataform"],
                    external_link: 'https://vivemas.com.co/productos'
                },
                {
                    image: 'landing-pages/guia-practica/desktop.png',
                    title: 'Guia Práctica en Seguriad Vial',
                    description: 'Landing Page/Volante para la atracción de clientes interesados en la seguridad vial.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page", "digital_flyer"]
                },
                {
                    image: 'landing-pages/burger-box/desktop.png',
                    title: 'Burguer Box',
                    description: 'Landing Page/Volante para la atracción de clientes interesados en una hamburguesa especial.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page", "digital_flyer"],
                    external_link: 'http://www.winketing.com/volantes/productos/burger-box/'
                },
                {
                    image: 'landing-pages/desafio/desktop.png',
                    title: 'Desafio de Marketing',
                    description: 'Landing Page para la atracción de clientes interesados en participar por un plan de marketing digital.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page"],
                    external_link: 'https://winketing.com/desafio/'
                },
                {
                    image: 'landing-pages/unimat/desktop.png',
                    title: 'Unimat - Alfombras de calidad',
                    description: 'Landing Page/Volante para la atracción de clientes interesados en alformbras.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page", "digital_flyer"],
                    external_link: 'https://winketing.com/volantes/productos/unimat/'
                },
                {
                    image: 'landing-pages/cardio/desktop.png',
                    title: 'Vive mas - Brigada Cardiovascular',
                    description: 'Landing Page/Volante para la atracción de clientes interesados en tratamientos cardiovasculares.',
                    link: { text: 'Ver más', to: '' },
                    tools: ["html_css", "sass", "js"],
                    categories: ["landing_page", "digital_flyer"],
                    external_link: 'https://winketing.com/volantes/vivemas/brigada-cardiovascular/'
                }
            ]
        }
    },
    mounted() {
        M.AutoInit();
    },
    computed: {
        filter_work_cards() {
            let filter = [];
            if (this.categories.length <= 0) {
                filter = this.work_cards;
            } else {
                for (const key in this.work_cards) {
                    for (const key2 in this.categories) {
                        if (this.work_cards[key].categories.indexOf(this.categories[key2]) != -1) {
                            if (filter.indexOf(this.work_cards[key]) == -1) {
                                filter.push(this.work_cards[key]);
                            }
                        }   
                    }
                }
            }

            return filter;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';
@import '@/assets/css/_mixins.scss';

.works {
    .first {
        position: relative;
        color: #FFFFFF;
        background-color: $main-black-2;
        height: 100vh;
    }

    .top-tools {
        margin: 1rem 0px 1rem 0px;
        .category-select {
            max-width: 350px
        }
    }

    .container-cards {
        padding: 1rem 0px 1rem 0px;

        @media (min-width: 760px) {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
        @media (min-width: 1200px) {
            justify-content: flex-start;
        }
    }
}
</style>